import React, { useState, useEffect } from 'react';

function Relatorios() {
  const [currentTenantId, setCurrentTenantId] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const lookerStudioBaseUrl = "https://lookerstudio.google.com/embed/reporting/04c75806-5a0a-47ca-b6bd-20b610676f33/page/uI8PF";

  useEffect(() => {
    const storedTenantId = localStorage.getItem('tenantId');

    if (storedTenantId) {
      setCurrentTenantId(storedTenantId);
    } else {
      console.warn("Tenant ID não encontrado no localStorage. O relatório pode não filtrar corretamente.");
    }
    setIsLoading(false);
  }, []);

  if (isLoading) {
    return <div>Carregando relatório...</div>;
  }

  if (!currentTenantId) {
    return <div>Não foi possível carregar o ID do tenant. Por favor, faça login novamente.</div>;
  }

  const params = {
    "ds18.tenantId": currentTenantId
  };

  const encodedParams = encodeURIComponent(JSON.stringify(params));

  const lookerStudioUrl = `${lookerStudioBaseUrl}?params=${encodedParams}`;
  
  return (
    <div style={{ width: '100%', height: '800px' }}>
      <iframe
        width="100%"
        height="100%"
        src={lookerStudioUrl}
        frameBorder="0"
        style={{ border: 0 }}
        allowFullScreen
        sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
      ></iframe>
    </div>
  );
}

export default Relatorios;